// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://njhjamsklyeznrohctkq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5qaGphbXNrbHllem5yb2hjdGtxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYzNDQ3MTEsImV4cCI6MjA1MTkyMDcxMX0.LJqNXwOr7To797JAl24HLcDdWFL3s9CQOFh1o_4R5yU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});